/**
 * M71 机甲：未改键 `getKeyboardKeys` 样例（layer0）→ 布局 HID / 分位值 → `pos`。
 * 与 `KEYBOARD_LAYOUTS.m71` 虚拟键盘回显、改键/灯光 pos 解析一致；与 M80 坐标系不同，勿写入 `M80_DEFAULT_POS_BY_KEYCODE`。
 */
const CB_VALUE_TO_HID: Readonly<Record<number, number>> = {
  65536: 224,
  131072: 225,
  262144: 226,
  524288: 227,
  1048576: 228,
  2097152: 229,
  4194304: 230,
  218103808: 61697,
};

/** 设备上报的 [value, pos]；与用户提供初始化表一致 */
const M71_INIT_VALUE_POS: ReadonlyArray<readonly [number, number]> = [
  [41, 12],
  [43, 16],
  [57, 20],
  [131072, 24],
  [65536, 28],
  [30, 36],
  [20, 40],
  [4, 44],
  [29, 48],
  [524288, 52],
  [31, 60],
  [26, 64],
  [22, 68],
  [27, 72],
  [262144, 76],
  [32, 84],
  [8, 88],
  [7, 92],
  [6, 96],
  [33, 108],
  [23, 112],
  [9, 116],
  [25, 120],
  [34, 132],
  [28, 136],
  [10, 140],
  [11, 164],
  [17, 168],
  [5, 144],
  [44, 148],
  [35, 156],
  [36, 180],
  [24, 184],
  [13, 188],
  [16, 192],
  [14, 212],
  [37, 204],
  [12, 208],
  [54, 216],
  [4194304, 220],
  [38, 228],
  [18, 232],
  [15, 236],
  [55, 240],
  [218103808, 244],
  [39, 252],
  [19, 256],
  [51, 260],
  [56, 264],
  [101, 268],
  [45, 276],
  [47, 280],
  [52, 284],
  [46, 300],
  [48, 304],
  [50, 308],
  [100, 312],
  [1048576, 316],
  [42, 324],
  [49, 328],
  [40, 332],
  [2097152, 336],
  [80, 340],
  [73, 348],
  [77, 352],
  [76, 356],
  [82, 360],
  [81, 364],
  [74, 372],
  [75, 376],
  [78, 380],
  [79, 388],
];

function buildM71FactoryPosByKeycode(): Readonly<Record<number, number>> {
  const o: Record<number, number> = {};
  for (const [value, pos] of M71_INIT_VALUE_POS) {
    const hid = CB_VALUE_TO_HID[value] ?? value;
    o[hid] = pos;
  }
  /** 与 `KEYBOARD_LAYOUTS.m71` 底行 Menu 虚拟码一致 */
  o[21252] = o[101] ?? 268;
  return o;
}

export const M71_FACTORY_POS_BY_KEYCODE: Readonly<Record<number, number>> =
  buildM71FactoryPosByKeycode();

/** M71 layer0 出厂顺序（与 SDK gx 解析 light_pos=8+t 一致，供 setGifLight 兜底） */
export function buildM71FactoryKeyboardKeysForGifLight(
  maxSlots = 126,
  baseLightPos = 8
): Array<{ value: number; pos: number; light_pos: number }> {
  return M71_INIT_VALUE_POS.slice(0, maxSlots).map(([value, pos], index) => ({
    value,
    pos,
    light_pos: baseLightPos + index,
  }));
}
